import script from "./conf-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./conf-drawer.vue?vue&type=script&lang=ts&setup=true"

import "./conf-drawer.vue?vue&type=style&index=0&id=17c44cb3&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17c44cb3"]])

export default __exports__